import { render, staticRenderFns } from "./shortAnswerTM.vue?vue&type=template&id=b9fe40ac&scoped=true&"
import script from "./shortAnswerTM.vue?vue&type=script&lang=js&"
export * from "./shortAnswerTM.vue?vue&type=script&lang=js&"
import style0 from "./shortAnswerTM.vue?vue&type=style&index=0&id=b9fe40ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fe40ac",
  null
  
)

export default component.exports